import { render } from "./ShadowCardHighlight.vue?vue&type=template&id=03d90c5d&scoped=true"
import script from "./ShadowCardHighlight.vue?vue&type=script&lang=js"
export * from "./ShadowCardHighlight.vue?vue&type=script&lang=js"

import "./ShadowCardHighlight.vue?vue&type=style&index=0&id=03d90c5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d90c5d"]])

export default __exports__